// Startup clean-up of the conversations earlier versions kept in this browser: deletes the IndexedDB database gridcode (the old Assistant thread store), so no chat text stays on the device now that the server keeps conversations per user; every failure is ignored.
export const LEGACY_DATABASE = "gridcode";

export function purgeLegacyThreadStore(factory?: IDBFactory): Promise<boolean> {
  return new Promise((resolve) => {
    try {
      const target = factory ?? (typeof indexedDB === "undefined" ? undefined : indexedDB);
      if (target === undefined) {
        resolve(false);
        return;
      }
      const request = target.deleteDatabase(LEGACY_DATABASE);
      request.onsuccess = () => {
        resolve(true);
      };
      request.onerror = () => {
        resolve(false);
      };
      request.onblocked = () => {
        resolve(false);
      };
    } catch {
      resolve(false);
    }
  });
}
